import React from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';

import styles from './EssentialContent.module.less';
// import { propTypes } from 'react-bootstrap/esm/Image';

const { Content } = Layout;

function EssentialContainer(props) {

  const {
    // eslint-disable-next-line
    children, headerComponent, footerComponent, applyPadding, applyWidthLimit,
  } = props;

  return (
    <Content className={styles.content}>
      {headerComponent && <header>{headerComponent}</header>}
      <div className={`${styles.main_content} ${applyPadding ? styles.apply_padding : ''}`}>
        <div className={`${applyWidthLimit ? styles.apply_width_limit : ''}`}>{children}</div>
      </div>
      {footerComponent && <footer>{footerComponent}</footer>}
    </Content>
  );

}

EssentialContainer.propTypes = {
  headerComponent: PropTypes.node,
  footerComponent: PropTypes.node,
  applyPadding: PropTypes.bool,
  applyWidthLimit: PropTypes.bool,
};

EssentialContainer.defaultProps = {
  headerComponent: null,
  footerComponent: null,
  applyPadding: true,
  applyWidthLimit: false,
};

export default EssentialContainer;
